import SeoHead from "./SeoHead";

/**
 * Etiquetas de cabecera (document.head) para pantallas que no deben indexarse (Stripe, confirmaciones…).
 * No es SEO para rankear: solo título en la pestaña + meta robots noindex para los buscadores.
 */
export default function PageHeadNoIndex({ title, description }) {
	return <SeoHead title={title} description={description} noIndex />;
}
